import React, { useState } from 'react';
import { File, Flag } from 'react-feather';
import { useGeneralContext } from '../../context';
import { updateUserData } from '../../api';
import { Colors } from './types';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { Chip, Divider } from '@mui/material';
import { JumbleBotSwitch } from './AiAssistantToggle';
import PremiumUpsellModal from '../../components/PremiumUpsellModal';

const ITEM_HEIGHT = 48;

const ColorSetting = (props: { setBgColor: React.Dispatch<React.SetStateAction<string>> }) => {
  const { setBgColor } = props;
  return (
    <ul className="tw-flex tw-flex-row tw-items-start tw-list-none tw-p-0">
      <li className="tw-m-1">
        <button
          onClick={() => {
            updateUserData({ entryBackgroundColor: Colors.White });
            setBgColor(Colors.White);
          }}
          style={{ backgroundColor: Colors.White }}
          className="tw-w-6 tw-h-6 tw-rounded-full tw-border tw-border-neutral-300 tw-cursor-pointer"
        ></button>
      </li>
      <li className="tw-m-1">
        <button
          onClick={() => {
            updateUserData({ entryBackgroundColor: Colors.Brown });
            setBgColor(Colors.Brown);
          }}
          style={{ backgroundColor: Colors.Brown }}
          className="tw-w-6 tw-h-6 tw-rounded-full tw-border tw-border-neutral-300 tw-cursor-pointer"
        ></button>
      </li>
      <li className="tw-m-1">
        <button
          onClick={() => {
            updateUserData({ entryBackgroundColor: Colors.Blue });
            setBgColor(Colors.Blue);
          }}
          style={{ backgroundColor: Colors.Blue }}
          className="tw-w-6 tw-h-6 tw-rounded-full tw-border tw-border-neutral-300 tw-cursor-pointer"
        ></button>
      </li>
      <li className="tw-m-1">
        <button
          onClick={() => {
            updateUserData({ entryBackgroundColor: Colors.Green });
            setBgColor(Colors.Green);
          }}
          style={{ backgroundColor: Colors.Green }}
          className="tw-w-6 tw-h-6 tw-rounded-full tw-border tw-border-neutral-300 tw-cursor-pointer"
        ></button>
      </li>
      <li className="tw-m-1">
        <button
          onClick={() => {
            updateUserData({ entryBackgroundColor: Colors.Dark });
            setBgColor(Colors.Dark);
          }}
          style={{ backgroundColor: Colors.Dark }}
          className="tw-w-6 tw-h-6 tw-rounded-full tw-border tw-border-neutral-300 tw-cursor-pointer"
        ></button>
      </li>
    </ul>
  );
};

const MeatballMenu = (props: {
  journalAssistant: boolean;
  setJournalAssistant: React.Dispatch<React.SetStateAction<boolean>>;
  setEntryBackgroundColor: React.Dispatch<React.SetStateAction<string>>;
  entryBackgroundColor: string;
  setBlur: React.Dispatch<React.SetStateAction<boolean>>;
  onUpgradeClick: () => void;
}) => {
  const context = useGeneralContext();
  const { setFeedbackModalOpen, subscriptionStatus } = context;
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [showModule, setShowModule] = useState(false);
  const open = Boolean(anchorEl);

  const {
    journalAssistant,
    setJournalAssistant,
    setEntryBackgroundColor,
    entryBackgroundColor,
    setBlur,
    onUpgradeClick
  } = props;

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setBlur(true);
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setBlur(false);
    setAnchorEl(null);
  };

  const toggleJumbleBot = () => {
    setBlur(false);
    if (journalAssistant) {
      return setJournalAssistant(false);
    }

    if (!subscriptionStatus || subscriptionStatus === 'free') {
      setShowModule(true);
      return;
    }
    setJournalAssistant(true);
    window.alert('Journaling Assistant is ready! Press enter while journaling to start the conversation.');
  };

  return (
    <div className="tw-pointer-events-auto tw--mr-3 tw-w-12 tw-h-12 tw-rounded-full tw-border-none tw-flex tw-items-center tw-justify-center">
      <PremiumUpsellModal
        showModal={showModule}
        setShowModal={setShowModule}
        message="Get access to the Jumble Assistant and get more out of your journaling experience"
        onUpgradeClick={onUpgradeClick}
      />
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreHorizIcon
          className={entryBackgroundColor === Colors.Dark ? 'tw-text-primary-100' : 'tw-text-primary-900'}
        />
      </IconButton>
      <Menu
        id="long-menu"
        MenuListProps={{
          'aria-labelledby': 'long-button'
        }}
        anchorEl={anchorEl}
        open={open}
        style={{ opacity: '.8' }}
        onClose={handleClose}
        slotProps={{
          paper: {
            style: {
              maxHeight: ITEM_HEIGHT * 4.5,
              width: '20ch'
            }
          }
        }}
      >
        <div className="tw-flex tw-flex-row tw-justify-between tw-items-center tw-p-2 tw-px-4">
          <JumbleBotSwitch
            onClick={() => {
              toggleJumbleBot();
            }}
            journalAssistant={journalAssistant}
          />
        </div>
        <Divider />
        <MenuItem
          key="report"
          selected={false}
          onClick={() => {
            setFeedbackModalOpen(true);
            handleClose();
          }}
        >
          <div className="tw-w-full tw-mr-2 tw-flex tw-flex-row tw-justify-between">
            <div className="tw-font-normal tw-text-base tw-text-neutral-800">Report</div>
            <Flag size={18} />
          </div>
        </MenuItem>
        <MenuItem
          key="feedback"
          selected={false}
          onClick={() => {
            setFeedbackModalOpen(true);
            handleClose();
          }}
        >
          <div className="tw-w-full tw-mr-2 tw-flex tw-flex-row tw-justify-between">
            <div className="tw-font-normal tw-text-base tw-text-neutral-800">Feedback</div>
            <File size={18} />
          </div>
        </MenuItem>
        <Divider>
          <Chip label="Choose a Color" />
        </Divider>
        <ColorSetting setBgColor={setEntryBackgroundColor} />
      </Menu>
    </div>
  );
};

export default MeatballMenu;
